module.exports = __webpack_public_path__ + "static/media/engineering0.42cbc02c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/department-module/engineering0.jpg
// module id = 714
// module chunks = 0